<a [routerLink]="['/accounts/sign-up']" class="hdr-btn text-white">
  <span>
    <i class="fa fa-user mr-1" aria-hidden="true"></i>
    Sign Up
  </span>
</a>
